import { FloatNumberInput } from "@/shared/components/domain/qpm/inputs/number-input";
import { Label } from "@/shared/components/ui/label";
import { useQpmMonitorBasePriceMutation } from "@/services/backend/qpm/monitors/api/monitor-api";
import { useState } from "react";
import { UpdateBasePriceReq } from "@/services/backend/qpm/monitors/types/monitor-commands";
import { useDebouncedMutationWithPersistenceStateContextUpdate } from "@/shared/lib/debounce/debounce";

export function MonitorBasePriceComponent({
  monitorId,
  price,
}: {
  monitorId: string;
  price?: number;
}) {
  const [update, { error, isLoading, isSuccess, reset }] =
    useQpmMonitorBasePriceMutation();

  const [request, setRequest] = useState<UpdateBasePriceReq>({
    id: monitorId,
    euros: price || 0,
    effectiveOn: new Date().toISOString(),
  });

  useDebouncedMutationWithPersistenceStateContextUpdate(
    request,
    update,
    isLoading,
    error,
    isSuccess,
    reset,
    250,
  );

  return (
    <div className="grid gap-1.5 sm:grid-cols-4">
      <Label className="sm:col-span-2" htmlFor="price">
        Preis
      </Label>

      <div className="min-w-0 sm:col-span-2">
        <FloatNumberInput
          id="price"
          value={price || 0}
          onBlur={(val: number) => setRequest({ ...request, euros: val })}
        />
      </div>
    </div>
  );
}
